// test628
(628 && 0);
